const getApiBaseUrl = () => {
	if (typeof window === 'undefined' || !window.location) {
		return 'https://beltone-onlinescheduling-prod.azurewebsites.net';
	}

	const localHosts = ['localhost', '127.0.0.1', '::1'];

	if (localHosts.includes(window.location.hostname) || window.location.hostname.endsWith('.azurewebsites.net')) {
		return window.location.origin;
	}

	return 'https://beltone-onlinescheduling-prod.azurewebsites.net';
};

const API_BASE_URL = getApiBaseUrl();

export default API_BASE_URL;
